// DS: C27
// TODO port this to streams - https://phrac.deviantart.net/D23153
// TODO add error handling
// TODO convert to use tooltip library
import React, { useState, useEffect, useRef, useCallback, useMemo, } from 'react';
import throttle from 'lodash/throttle';
import FocusTrap from 'focus-trap-react';
import LoadingIndicator from '../LoadingIndicator';
import NoLeakyScroll from '../NoLeakyScroll';
import { EmoteStreamType } from './redux/types';
import { streamTypeToSearchType } from './constants';
import TabsHeader from './TabsHeader';
import EmoteSelectorPopupWrapper from './EmoteSelectorPopupWrapper';
import EmoteList from './EmoteList';
import SearchHeader from './SearchHeader';
import s from './EmoteSelector.scss';
export var EmoteSelector = function (_a) {
    var activeStream = _a.activeStream, isLoading = _a.isLoading, onLoadMore = _a.onLoadMore, buttonRect = _a.buttonRect, isLoadingStream = _a.isLoadingStream, switchStream = _a.switchStream, onEmoteSelect = _a.onEmoteSelect, onInitialize = _a.onInitialize, onClose = _a.onClose;
    var scrollContainerRef = useRef(null);
    var _b = useState(false), isSearchOpen = _b[0], setIsSearchOpen = _b[1];
    useEffect(function () {
        onInitialize();
    }, [onInitialize]);
    var handleContainerScroll = useMemo(function () {
        return throttle(function (e) {
            requestAnimationFrame(function () {
                if (e.target.scrollHeight -
                    (e.target.scrollTop + e.target.clientHeight) <
                    100) {
                    if (!isLoading && (activeStream === null || activeStream === void 0 ? void 0 : activeStream.hasMore)) {
                        onLoadMore();
                    }
                }
            });
        }, 300);
    }, [isLoading, activeStream, onLoadMore]);
    var resetScroll = useCallback(function () {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.children[0].scrollTop = 0;
        }
    }, [scrollContainerRef]);
    useEffect(function () {
        var scrollElement = scrollContainerRef.current;
        if (scrollElement) {
            scrollElement.addEventListener('scroll', handleContainerScroll, true);
        }
        return function () {
            if (scrollElement) {
                scrollElement.removeEventListener('scroll', handleContainerScroll);
            }
        };
    }, [scrollContainerRef, handleContainerScroll]);
    var closeSearch = useCallback(function () {
        switchStream({
            streamType: EmoteStreamType.OFFICIAL,
            searchType: streamTypeToSearchType[EmoteStreamType.OFFICIAL],
            searchQuery: '',
        });
        setIsSearchOpen(false);
    }, [switchStream]);
    var handleEmoteSelect = useCallback(function (emote, e) {
        onEmoteSelect(emote);
        if (e && e.shiftKey) {
            return;
        }
        if (onClose)
            onClose({});
    }, [onClose, onEmoteSelect]);
    var openSearch = useCallback(function () {
        resetScroll();
        setIsSearchOpen(true);
    }, [resetScroll, setIsSearchOpen]);
    return (React.createElement(FocusTrap, { focusTrapOptions: {
            clickOutsideDeactivates: true,
            onDeactivate: function () {
                if (onClose) {
                    onClose({});
                }
            },
        } },
        React.createElement(EmoteSelectorPopupWrapper, { buttonRect: buttonRect },
            React.createElement("div", { className: s['header'] },
                isSearchOpen && React.createElement(SearchHeader, { onClose: closeSearch }),
                !isSearchOpen && React.createElement(TabsHeader, { onOpenSearch: openSearch })),
            React.createElement("div", { className: s['items'], ref: scrollContainerRef },
                React.createElement(NoLeakyScroll, { className: s['scroll-area'] },
                    !isLoadingStream && (React.createElement(EmoteList, { onEmoteSelect: handleEmoteSelect })),
                    (isLoading || isLoadingStream) && (React.createElement(LoadingIndicator, { view: "llama", className: s['loading'] })),
                    React.createElement("div", { className: s['overlay'] }))))));
};
export default EmoteSelector;
//# sourceMappingURL=EmoteSelector.js.map